import CopyTextWithButton from "components/basic/copy-text-with-button/CopyTextWithButton";
import React from 'react';
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {standardDeviation} from "utils/utils";
import {DatasetDataInfoResponse} from "api/model/dataset/DatasetDataInfoResponse";


type DatasetStatusShowerProps = {
    dialog: boolean,
    setDialog: (val: boolean) => void,
    datasets: Array<DatasetDataInfoResponse>
}

const DatasetStatusShower = ({dialog, setDialog, datasets}: DatasetStatusShowerProps) => {
    const fixedTo = 2;
    const titleBodyTemplate = (rowData: any) => {
        return <CopyTextWithButton text={rowData.title} copyableText={rowData.title}/>
    }

    return <Dialog visible={dialog} onHide={() => setDialog(false)} header={"Statistics"}>
        <DataTable removableSort sortMode={"multiple"} value={datasets.map(dataset => {
            const nrArr: Array<number> = dataset.data.map(e => e.value)
            const average = nrArr.reduce((x, y) => x + y) / nrArr.length;
            const sum = nrArr.reduce((x, y) => x + y);
            const min = Math.min(...nrArr);
            const max = Math.max(...nrArr);

            if (nrArr.length > 0) {
                return {
                    ...dataset,
                    average: average.toFixed(fixedTo),
                    sum: sum.toFixed(fixedTo),
                    min: min.toFixed(fixedTo),
                    max: max.toFixed(fixedTo),
                    count: nrArr.length,
                    delta: (max - min).toFixed(fixedTo),
                    std: standardDeviation(nrArr, average)?.toFixed(fixedTo)
                }
            }
            return dataset
        })}>
            <Column header={"Title"} field={"title"} sortable body={titleBodyTemplate}/>
            <Column header={"Unit"} field={"unit"} style={{width: 0}} body={(data) => data.unit || "-"}
                    sortable/>
            <Column header={"Count"} field={"count"} style={{width: 0}} body={(data) => data.count || "-"} sortable/>
            <Column header={"Sum"} field={"sum"} style={{width: 0}} body={(data) => data.sum || "-"}
                    sortable/>
            <Column header={"Min"} field={"min"} style={{width: 0}} body={(data) => data.min || "-"}
                    sortable/>
            <Column header={"Max"} field={"max"} style={{width: 0}} body={(data) => data.max || "-"}
                    sortable/>
            <Column header={"Delta"} field={"delta"} style={{width: 0}} body={(data) => data.delta || "-"}
                    sortable/>
            <Column header={"Mean"} field={"average"} style={{width: 0}}
                    body={(data) => data.average || "-"} sortable/>
            <Column header={"Std"} field={"std"} style={{width: 0}} body={(data) => data.std || "-"}
                    sortable/>
        </DataTable>
    </Dialog>;
};

export default DatasetStatusShower;